import NoResultAtributtes from "../../NoResultAtributtes/NoResultAtributtes";

const TableHistory = ({
  attributes,
  titles,
  className,
  attType,
  status,
}: {
  titles: string;
  attType: string;
  className: string;
  status: string;
  attributes: {
    subTitle: string;
    value: string;
  }[];
}) => {
  const renderContent = () => {
    if (attributes.length === 0) {
      if (attType === "NCM") {
        return <NoResultAtributtes />;
      }

      if (status) {
        const text = ["NOVO", "EM_CLASSIFICACAO", "RECLASSIFICAR"].includes(
          status
        )
          ? "Dados não finalizados. Complete para visualizar."
          : "Informação não necessária para esse NCM.";

        return <span className="noResults">{text}</span>;
      }

      return null;
    }

    return (
      <ul>
        {attributes.map((attr) => (
          <li key={attr.value}>
            {attr.subTitle ? (
              <>
                <span>{attr.subTitle}: </span> <p>{attr.value}</p>
              </>
            ) : (
              <span>{attr.value}</span>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div>
      <h2 className="h2-material">{titles}</h2>
      <div className={className}>{renderContent()}</div>
    </div>
  );
};

export default TableHistory;
